export default theme => ({

	mediaBar: {
		width: "87%",
		height: "70px",
		position: "absolute",
		backgroundColor: "rgba(254, 253, 248, 1)",
		bottom: "1vh",
		left: "7.25rem",
		margin: "10px",
		display: "flex",
		padding: "0px",
		alignItems: "center",
		flexDirection: "row",
		justifyContent: "space-between",
		[theme.breakpoints.down("sm")]: {
			width: "100%",
			height: "50px",
			left: "unset",
			margin: "unset",
			visibility: "hidden"
		}
	},

	appBar: {
		display: "flex",
		backgroundColor: theme.palette.background.default,
		transition: theme.transitions.create(["width", "margin"], {
			duration: theme.transitions.duration.leavingScreen,
			easing: theme.transitions.easing.sharp
		}),
		zIndex: theme.zIndex.drawer + 1
	},
	mediaIcons: {
		position: "absolute",
		top: 10,
		right: theme.spacing.unit * 2,
		display: "flex",
		fontWeight: 900,
		zIndex: 2
	},
	icon: {
		cursor: "pointer",
		"& path": {
			fill: theme.palette.primary.main
		},
		width: "36px",
		height: "36px",
		margin: "6px 6px 6px 6px",
		"&:hover path": {
			fill: theme.palette.secondary.main
		}
	},
	officeVersionVideo: {
		width: "100%",
		height: "75vh"
	},
	video: {
		width: "100%",
		height: "100%",
		maxWidth: 1024,
		margin: "auto",
		cursor: "pointer"
	},
	underHeaderLine: {
		borderTopWidth: 4,
		borderColor: theme.palette.primary.main,
		borderStyle: "solid"
	},
	filters: {},
	mediaSlideShow: {
		top: 0,
		left: 0,
		right: 0,
		width: "100vw",
		bottom: 0,
		height: "100vh",
		zIndex: 1205,
		position: "fixed",
		background: "rgba(0, 0, 0, 0.9)",
		alignItems: "center",
		display: "flex",
		"& .image-gallery": {
			width: "100%",
			"& :focus": {
				outline: "none"
			},
			"& .image-gallery-content":{
				"& .image-gallery-slide":{
					"& .image-gallery-image":{
						maxWidth: "100%",
						maxHeight: "69vh",
						minHeight: "69vh"
					}
				}
			}
		},
		"& h6": {
			top: "5px",
			position: "absolute",
			marginLeft: "auto",
			marginRight: "auto",
			left: 0,
			right: 0,
			margin: 0,
			textTransform: "capitalize",
			fontFamily: "Inter",
			fontStyle: "normal",
			fontWeight: 500,
			fontSize: "32px",
			lineHeight: "39px",
			textAlign: "center"
			//color: "#FEFDF8"
		}
	},
	backActions: {
		position: "absolute",
		top: 10,
		right: theme.spacing.unit * 2,
		display: "flex",
		fontWeight: 900,
		zIndex: 2,
		"& span": {
			cursor: "pointer"
		}
	},
	closeSlideShowBtn: {
		position: "absolute",
		top: "40px",
		right: "26px",
		minWidth: "auto",
		marginRight: theme.spacing.unit,
		borderRadius: "0px",
		border: "1px solid 	rgba(255, 189, 84, 1)",
		padding: "1px",
		backgroundClip: "content-box",
		backgroundColor: "rgba(255, 189, 84, 1)",
		width: "54px",
		height: "54px",
		transform: "rotate(45deg)",
		zIndex: "100"
	},
	closeSlideShowBtnIco: {
		transform: "rotate(-45deg)",
		fill: "rgba(254, 253, 248, 1)",
		width: "26px",
		height: "26px"

	},
	advancedSearch: {
		position: "absolute",
		right: 0,
		marginRight: theme.spacing.unit * 5,
		display: "flex",
		alignItems: "center"
	},
	btnOpenSidebar: {
		transform: "rotate(0deg)",
		transition: "transform 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms"
	},
	advancedSearchOpened: {
		transform: "rotate(45deg)"
		// backgroundColor: theme.palette.primary.dark
	},
	advancedMediaOpened: {
		transform: "rotate(45deg)"
		// backgroundColor: theme.palette.primary.dark
	},
	logo: {
		width: 123
	},
	filter: {
		display: "inline-flex",
		alignItems: "center",
		marginRight: theme.spacing.unit * 3,
		"&:last-child": {
			margin: 0
		}
	},
	office: {
		width: "100%",
		display: "flex",
		alignItems: "center",
		justifyContent: "center"
	},
	root: {
		display: "flex"
	},
	title: {
		marginRight: theme.spacing.unit * 3
	},
	toolbar: {
		...theme.mixins.toolbar,
		alignItems: "center"
	},
	btn: {
		width: 30,
		height: 30,
		"@media (min-width:960px) and (max-width:1440px)": {
			width: 24,
			height: 24
		},
		"& svg": {
			"@media (min-width:960px) and (max-width:1440px)": {
				width: 18,
				height: 18
			}
		}
	},
	[theme.breakpoints.down("md")]: {
		filter: {
			marginRight: theme.spacing.unit
		},
		toolbar: {
			padding: theme.spacing.unit
		},
		advancedSearch: {
			marginRight: theme.spacing.unit
		},
		title: {
			marginRight: theme.spacing.unit
		}
	},
	[theme.breakpoints.down("sm")]: {
		mediaIcons: {
			position: "relative"
		}
	},
	gridContainer: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		padding: "0px",
		gap: "2.5rem",
		justifyContent: "space-around",
		margin: "10px",
		[theme.breakpoints.down("sm")]: {
			flexDirection: "row",
			gap: "1.5rem"
		}
	},
	gridItem: {
		flexGrow: "0",
		flex: "none",
		margin: "auto",
		display: "contents",
		cursor: "pointer"
	},
	img: {
		position: "relative"
	},
	mailImg:{
		position: "relative",
		width: "30px",
		height: "30px"
	},
	textMediabar: {
		fontFamily: "Inter",
		fontStyle: "normal",
		fontWeight: "400",
		fontSize: "12px",
		lineHeight: "15px",
		textAlign: "center",
		textDecoration: "none",
		textTransform: "uppercase",
		position: "relative",
		width: "min-content",
		color: "rgba(34, 34, 34, 1)",
		[theme.breakpoints.down("sm")]: {
			fontSize: "8px",
			lineHeight: "10px"
		}
	},
	separatorMediabar: {
		color: "rgba(255, 137, 49, 1)",
		fontWeight: "bold"
	},
	logoVectuel: {
		width: "160px",
		height: "61px",
		"& path:first-child": {
			fill: "#222222"
		}
	},
	interPNG: {
		height: "50px",
		width: "100px",
		[theme.breakpoints.down("sm")]: {
			width: "50px",
			height: "25px"
		}
	},
	villePNG: {
		height: "50px",
		[theme.breakpoints.down("sm")]: {
			width: "50px",
			height: "25px"
		}
	}

})
